import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';

import { POST_ROWS_PER_PAGE } from './constants';

export const getBlogSearchFilters = ({ search, tag, category, rowsPerPage, page }) => {
  const defaultFilter = {
    page: !isNil(page) ? page : 1,
    limit: !isNil(rowsPerPage) ? rowsPerPage : POST_ROWS_PER_PAGE,
  };

  if (!isNil(search) && !isEmpty(search)) {
    defaultFilter.search = search;
  }

  if (!isNil(tag)) {
    defaultFilter.tag = tag;
  }

  if (!isNil(category)) {
    defaultFilter.category = category;
  }

  return defaultFilter;
};
